import React, { useEffect } from 'react';

import Layout from '../../containers/Layout';
import ImageTitle, { Icons } from '../../components/ImageTitle';
import { Container, Content, Note } from './styles';
import { useDefaultGtm } from '../../hooks/gtm/default/useDefaultGtm';

const ProductOutOfStock = (props: any) => {
  const products = props?.location?.state && JSON.parse(props.location.state);
  const { sendDataToGtm } = useDefaultGtm();

  useEffect(() => {
    sendDataToGtm({
      type: 'checkout',
      name: '/pagamento/infos-pagamento-error',
    });
  }, []);

  return (
    <Layout dark>
      <Container>
        <ImageTitle
          data-cy='product-out-stock'
          icon={Icons.productOutOfStock}
          text="Ops, parece que não há mais estoque disponível para o(s) produto(s) contidos na venda."
          primary
        />

        {products &&
          products.map((product: any, index: number) => (
            <Content data-cy={`product-${index}`} key={product.id}>
              <strong>Item {(index + 1).toString().padStart(2, '0')}:</strong>{' '}
              {product.description}
            </Content>
          ))}

        <Note data-cy='note'>Favor entrar em contato com o vendedor!</Note>
      </Container>
    </Layout>
  );
};

export default ProductOutOfStock;
